import React, { useEffect, useState } from 'react'
import Dropdown from './commons/Dropdown'
import { countries, languages } from '../lib/FakeData'
import { BiUser } from 'react-icons/bi'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from "react-router-dom";
import { logoutClick } from '../redux/Actions/UserActions'
import { listProduct } from '../redux/Actions/ProductActions'
import { lisCategories } from '../redux/Actions/CategoryActions'
import { ORDER_DETAILS_RESET } from '../redux/Constants/OrderConstants'
import { formatNumber } from '../service'

export const Topbar = () => {
  const dispatch = useDispatch();
  const [dataU, setDataU] = useState({balance: 0});
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const logoutHandler = () => {
    dispatch(logoutClick());
  };
  const accountItems = [
    { id: 1, label: <Link to="/Register">Đăng kí</Link>, value: "Account" },
    { id: 2, label: <Link to="/login">Đăng nhập</Link>, value: "Account" },
    { id: 3, label: "Compare", value: "Account" },
    { id: 4, label: "Wishlist", value: "Account" },

  ];
  const accountItemsLogin = [
    // { id: 1, label:  <button type="button" className="">Hi, {userInfo?userInfo.name:""}</button>, value: "USD" },
    { id: 2, label: <Link className="" to="/profile">Hồ sơ</Link>, value: "EUR" },
    { id: 3, label: <Link className="" to="#" onClick={logoutHandler}>Đăng xuất</Link>, value: "RON" },

  ];

  useEffect(() => {
    dispatch(listProduct());
    dispatch(lisCategories());
    dispatch({ type: ORDER_DETAILS_RESET });
  }, [dispatch]);
  // console.log(userInfo);

  useEffect(() => {
    const interval = setInterval(() => {
      const stored = window.localStorage.getItem("userInfoActive");
      if (stored) {
        try {
          const data = JSON.parse(stored);
          setDataU(data);
        } catch (error) {
          console.error("Error parsing userInfoActive:", error);
        }
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='h-[40px] w-full bg-[--color-bg] flex items-center justify-center'>
      <div className='w-[--page-width] grid grid-cols-2'>
        <div className='hidden xl:flex items-center'>
          <p className='m-0 text-sm'>Khách hàng thân thiết nhận ngay phần thưởng 9.200.000đ
            Tiêu dùng cá nhân - Tiêu dùng tích lũy</p>
        </div>
        <div className='col-span-2 xl:col-span-1 flex gap-2 justify-center xl:justify-end items-center '>
          {/* <div className='flex items-center'>
            <Dropdown items={countries} onSelect={()=>{}}  value={countries[0]} placeholder='Currency' className={""} />
          
            <div className="w-1 border-l border-l-gray-300 h-[30px]"></div>
          </div> */}
          <div>
            {/* <Dropdown items={languages} onSelect={()=>{}} value={languages[0]} placeholder='language' /> */}

            <span className="flex w-1/3 xl:w-auto text-sm xl:text-base font-bold text-red-600 gap-2">
              <img src="/images/logoToken.png" style={{ width: 20 }} /> {formatNumber(dataU?.balance, 2)}
            </span>
          </div>

          <div>
            <Dropdown isSetSelect={false} searchable={false} items={
              !userInfo ? accountItems : accountItemsLogin} onSelect={() => { }} value={""} placeholder={userInfo ? `Hi, ${userInfo ? userInfo.name : ""}` : "Người dùng"} icon={<BiUser />} />
          </div>

        </div>

      </div>

    </div>
  )
}
